import React from 'react';
import { styled } from 'styled-components';

import { Media } from '../../theme/Media.tsx';
import { useTableContext } from './context.tsx';

const Wrapper = styled.div<{ $sup?: boolean; $isCollapsedNav?: boolean }>`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  font-size: 12px;
  @media ${({ $isCollapsedNav }) => ($isCollapsedNav ? Media.lgMin : Media.xlgMin)} {
    margin: ${({ $sup }) => ($sup ? '0 0 -10px 0' : '10px 0 0 0')};
  }
`;

const Numbers = styled.span`
  color: ${({ theme }) => theme.colors.grey70_1};
`;

export interface ITableFooter {
  total: number;
  current: number;
  page?: number;
  limit?: number;
  sup?: boolean;
  dataTestId?: string;
}

const Footer: React.FC<ITableFooter> = ({ total, current, page, limit, sup, dataTestId }) => {
  const { isCollapsedNav } = useTableContext();
  return (
    <Wrapper $sup={sup} $isCollapsedNav={isCollapsedNav}>
      <Numbers data-testid={dataTestId}>
        {page && limit ? `${(page - 1) * limit + 1} - ${(page - 1) * limit + current} / ${total}` : `1 - ${current} / ${total}`}
      </Numbers>
    </Wrapper>
  );
};

export default React.memo(Footer);
